var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDivisionLine32Filled = function SvgIconDivisionLine32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.667v-3.2c0-.44-.36-.8-.8-.8H8.8c-.44 0-.8.36-.8.8v3.2",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.867 21.467c0-1.066.868-1.933 1.934-1.933h14.4c1.065 0 1.933.867 1.933 1.933v3.2h-2.267v-2.866H9.134v2.866H6.867v-3.2Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.334v3.2c0 .44-.36.8-.8.8H8.8c-.44 0-.8-.36-.8-.8v-3.2",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.134 10.2V7.335H6.867v3.2c0 1.066.868 1.933 1.934 1.933h14.4a1.936 1.936 0 0 0 1.933-1.933v-3.2h-2.267v2.867H9.134ZM7 15h18v2H7v-2Z",
    fill: "current"
  })));
};
export default SvgIconDivisionLine32Filled;